import classNames from 'classnames';
import T from 'prop-types';
import React from 'react';
import withLazyLoad from '../Containers/withLazyLoad';
import withSrcSets from '../Containers/withSrcSets';

const Image = (props) => {
  const classes = classNames({
    'c-image': true,
    'c-image--is-lazyloaded': props.isLazyLoaded || !props.isLazyLoad,
    'c-image--is-background-image': props.isBackgroundImage,
    [props.className]: true && props.className,
  });

  const src = props.isLazyLoad ? props.LazyLoadImageUrl : props.ImageUrl;

  let alt = props.Description ?? props.ImageDescription;
  if (props.Alt !== undefined) alt = props.Alt;
  //If IMG is decorative alt text should be empty.
  if (props.isBackgroundImage || props.ariaHidden) alt = '';

  const style =
    props.isBackgroundImage && props.currentSrc
      ? {
          style: {
            backgroundImage: `url("${props.currentSrc}")`,
          },
        }
      : null;

  const sizes = props.SrcSets && props.SrcSets.srcSet ? props.Sizes : null;

  const attributes = props.isBackgroundImage ? { role: 'presentation' } : {};

  return (
    <div {...style} className={classes} {...attributes}>
      {(!props.isBackgroundImage || props.isViewed || !props.isLazyLoad) && (
        <img
          data-event-include={props.includeTracking ? true : undefined}
          src={src}
          {...props.SrcSets}
          alt={alt}
          onLoad={props.handleOnLoad}
          aria-hidden={props.ariaHidden}
          {...sizes}
        />
      )}
      {props.isLazyLoad && (
        <noscript
          dangerouslySetInnerHTML={{
            __html: `<img src="${props.ImageUrl}" alt="${alt}" />`,
          }}
        />
      )}
    </div>
  );
};

Image.propTypes = {
  className: T.string,
  currentSrc: T.string,
  Alt: T.string,
  isViewed: T.bool,
  isBackgroundImage: T.bool,
  isLazyLoad: T.bool,
  ariaHidden: T.bool,
  LazyLoadImageUrl: T.string,
  ImageUrl: T.string,
  SrcSets: T.shape({ srcSet: T.any }),
  Sizes: T.object,
};

export const LazyLoadImage = withSrcSets(withLazyLoad(Image));

export default Image;
